import { Box, Icon } from "@outschool/backpack";
import { faSearch } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function TooSpecific() {
  const { t } = useTranslation("client\\components\\search\\TooSpecific");
  return (
    <Box
      sx={{
        padding: "0.75em 1em",
        textAlign: "center",
        paddingY: "3em",
        paddingX: "1em",
      }}
    >
      <Icon
        icon={faSearch}
        sx={{
          fontSize: "4em",
        }}
      />
      <br />
      {t("Looks like your search filters are too specific!")}
      <br />
      {t("Try setting the filters to something more general.")}
    </Box>
  );
}
